import type { SVGProps } from 'react';

import { useSvgIdPrefix } from '../../svg-ids';

const ReactComponent = (props: SVGProps<SVGSVGElement>) => {
  const uid = useSvgIdPrefix('icon');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 563.34 506.81"
      {...props}
    >
      <defs>
        <linearGradient
          id={`${uid}a`}
          x1={-32.72}
          x2={219.37}
          y1={96.42}
          y2={442.02}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.27} stopColor="#afeaef" />
          <stop offset={0.4} stopColor="#abe6ee" />
          <stop offset={0.51} stopColor="#a1ddeb" />
          <stop offset={0.62} stopColor="#8fcde7" />
          <stop offset={0.72} stopColor="#76b7e1" />
          <stop offset={0.81} stopColor="#569ada" />
          <stop offset={0.9} stopColor="#3077d0" />
          <stop offset={0.92} stopColor="#2870cf" />
        </linearGradient>
        <linearGradient
          id={`${uid}b`}
          x1={261.91}
          x2={467.84}
          y1={131.37}
          y2={417.33}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.1} stopColor="#9ce6ef" />
          <stop offset={0.26} stopColor="#8ad4ea" />
          <stop offset={0.59} stopColor="#5ea5dd" />
          <stop offset={0.64} stopColor="#589fdc" />
          <stop offset={0.72} stopColor="#488ed7" />
          <stop offset={0.88} stopColor="#2d73d0" />
          <stop offset={0.98} stopColor="#2469ce" />
        </linearGradient>
      </defs>
      <path
        d="M228.72 327.23c-16.88 42.19-52.14 70.74-90.53 72.48-23.41 1.06-41.99-8.12-52-14.28a902 902 0 0 1-24.29-30.77 939 939 0 0 1-22.52-31.21C21.25 297.14-5.21 268.5.9 233.1c4.05-41.98 45.62-71.37 86.61-63.8 24.19 3.04 42.16 18.94 54.73 38.64 28.86 39.79 57.68 79.43 86.49 119.29Z"
        fill={`url(#${uid}a)`}
      />
      <path
        d="M502.81 193.57c-49.06 76.49-106.68 168.72-170.13 262.69-8.13 11.51-17.55 20.91-28.26 28.21-30.27 23.05-66.62 27.01-101.21 17.58-59.57-15.32-86.06-78.33-121.23-121.97 15.77 8.19 46.89 21.15 79.26 11.32 25.92-7.87 41.34-26.92 67.48-64.17 50.54-72.05 153.3-240.64 196.92-298.41C450.67-.86 496.42-9.6 529.02 12c31.04 18.96 42.26 60.37 28.56 94.06-15.2 29.34-38.43 62.88-54.77 87.51"
        fill={`url(#${uid}b)`}
      />
    </svg>
  );
};

export { ReactComponent };
